import { Button, ButtonGroup } from '@chakra-ui/button'
import { useDisclosure } from '@chakra-ui/hooks'
import { Icon } from '@chakra-ui/icon'
import { Input } from '@chakra-ui/input'
import { Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay } from '@chakra-ui/modal'
import { IoReceiptSharp } from 'react-icons/io5'
import { useRef, useState } from 'react'
import { Flex } from '@chakra-ui/layout'
import { user } from '../../../../helpers/user'
import { api, baseURL } from '../../../../services/api'

export function RecebimentoXbz({ data, onReload }) {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const numeroPedidoRef = useRef(null)
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  async function updateStatusAcompanhaCompras() {
    const codUsuario = user.codigo_usuario

    setLoading(true)

    const parametro = {
      cod_usu: codUsuario,
      numero_nota: data.numero_nota.split('|'),
      nunota: data.numero_nota.split('|'),
      codprod: data.cod_prod.split('|'),
      sequencia: data.sequencia.split('|'),
    }

    console.log('parametro', parametro)

    const response = await baseURL.post('/pedido/atualiza-status-compra-acompanhamento', parametro)

    console.log('RESPONSE', response)
    setLoading(false)
  }

  async function onSubmit(event) {
    event.preventDefault()
    const numeroPedido = numeroPedidoRef.current.value
    const codUsu = user.codigo_usuario

    if (!numeroPedido) {
      return setError(true)
    }

    setLoading(true)

    try {
      const params = {
        numero_pedido: numeroPedido,
        nome_usu_numxbz: codUsu,
        codigo_produto: data.cod_prod,
        numero_nota: data.numero_nota,
        sequencia: data.sequencia,
      }

      const response = await api.post('/site/v2/pedido/atualiza-numero-xbz', params)

      // await updateStatusAcompanhaCompras()
      onClose()
      // onReload()
      setLoading(false)
      setError(false)
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <Button colorScheme="blue" onClick={onOpen}>
        <Icon as={IoReceiptSharp} w="1.5rem" h="1.5rem" _hover={{ filter: 'brightness(0.8)' }} cursor={'pointer'} />
      </Button>

      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Recebimento XBZ</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Flex as="form" flexDir="column" gap={2} onSubmit={onSubmit}>
              <Input
                type="text"
                placeholder="Digite o número do pedido"
                ref={numeroPedidoRef}
                isInvalid={error}
                errorBorderColor="red.300"
                autoFocus
              />
              <ButtonGroup>
                <Flex gap={4}>
                  <Button type="submit" colorScheme="blue" isLoading={loading}>
                    Confirmar
                  </Button>
                  <Button type="reset" variant="ghost">
                    Limpar
                  </Button>
                </Flex>
              </ButtonGroup>
            </Flex>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  )
}
